export var KycRequestProcess;
(function (KycRequestProcess) {
    KycRequestProcess["EKycOnly"] = "e-kyc-only";
    KycRequestProcess["InformationRequestOnly"] = "information-request-only";
    KycRequestProcess["EKycAndInformationRequest"] = "e-kyc-and-information-request";
})(KycRequestProcess || (KycRequestProcess = {}));
export var KycRequest;
(function (KycRequest) {
    KycRequest["CustomRequest"] = "CUSTOM_REQUEST";
})(KycRequest || (KycRequest = {}));
//# sourceMappingURL=index.js.map